import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Grid,
  Box,
  Snackbar,
  Alert,
  TextField,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import { Save as SaveIcon } from "@mui/icons-material";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import { faBarChart } from "@fortawesome/free-solid-svg-icons";

const CcpAdminForms = () => {
  const formId = "ix25Z19hd05vXVjPivyG"; // Document ID in Firestore
  const [formData, setFormData] = useState({
    dropForm: "",
    proctorForm: "",
    testForm: "",
    courseChange: "",
    newCourseRequest: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const pageName = "Forms";
  const icon = faBarChart;

  const loadData = useCallback(async () => {
    try {
      const docRef = doc(db, "forms", formId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setFormData(docSnap.data());
      } else {
        console.error("No such document!");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  }, [formId]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      const docRef = doc(db, "forms", formId);
      await updateDoc(docRef, formData);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Failed to update data:", error);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container sx={{ marginTop: "100px" }}>
      {" "}
      <CcpAdminBreadCrumbs pageName={pageName} icon={icon} />
      <Card sx={{ marginTop: "10px" }}>
        <CardHeader
          title="Update Forms"
          sx={{ bgcolor: "#AC1A2F", color: "white" }}
        />
        <CardContent>
          <Box sx={{ flexGrow: 1, marginTop: "10px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Drop Form - Hide After Date"
                  type="date"
                  name="dropForm"
                  value={formData.dropForm}
                  onChange={handleDateChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  helperText="Leave empty to keep form visible. Set date to hide form after this date."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Proctor Form - Hide After Date"
                  type="date"
                  name="proctorForm"
                  value={formData.proctorForm}
                  onChange={handleDateChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  helperText="Leave empty to keep form visible. Set date to hide form after this date."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Test Form - Hide After Date"
                  type="date"
                  name="testForm"
                  value={formData.testForm}
                  onChange={handleDateChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  helperText="Leave empty to keep form visible. Set date to hide form after this date."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Course Change Form - Hide After Date"
                  type="date"
                  name="courseChange"
                  value={formData.courseChange}
                  onChange={handleDateChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  helperText="Leave empty to keep form visible. Set date to hide form after this date."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="New Course Request Form - Hide After Date"
                  type="date"
                  name="newCourseRequest"
                  value={formData.newCourseRequest}
                  onChange={handleDateChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  helperText="Leave empty to keep form visible. Set date to hide form after this date."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                {/* Course Planning Form date field moved to CcpAdminCoursePlanning.jsx */}
              </Grid>
            </Grid>
          </Box>
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={handleSave}
          >
            Save Changes
          </Button>
        </CardActions>
      </Card>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Forms have been updated
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CcpAdminForms;
